module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0012.b340157d.jpg";